module.exports = __webpack_public_path__ + "static/media/1.0641998a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/1.jpg
// module id = 74
// module chunks = 0